<template>
  <auth-layout pageClass="invitation-page">
    <br>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <form action="">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Invitation</h3>
              </div>

              <br>

              <div>
                <label> From: </label>
                <div class="ml-2"> {{$route.query.incentifyerCompanyName || 'N/A'}} </div>
              </div>

              <br>

              <template v-if="!$route.query.error">
                <div v-if="$route.query.decision == 'accept'">
                  <center> <span style="font-size:50px"><i class="fas fa-award text-success"/></span> </center>
                  <center> <span style="font-size:25px;">Accepted</span> </center>
                </div>

                <div v-if="$route.query.decision == 'decline'">
                  <br>
                  <!-- <center> <span style="font-size:50px"><i class="fas fa-frown-open text-success"/></span> </center> -->
                  <!-- <center> <span style="font-size:50px"><i class="fas fa-sad-cry text-success"/></span> </center> -->
                  <!-- <center> <span style="font-size:50px"><i class="fas fa-heart-broken text-success"/></span> </center> -->
                  <center> <span style="font-size:50px"><i class="fas fa-times-circle text-warning"/></span> </center>
                  <center> <span style="font-size:25px;">Declined</span> </center>
                </div>

                <br>
                <br>

              </template>

              <template v-else>
                <br>
                <div class="ml-auto">
                  <center><i style="font-size: 30px" class="fas fa-exclamation-triangle text-warning"/> &nbsp; {{$route.query.error}} </center>
                  </div>
                <br>
              </template>
              
              <template v-if="$route.query.userActivationCode && $route.query.userActivationCode != 'undefined' " class="text-center">
                <div v-if="$route.query.decision == 'accept'" class="text-center">
                  <button type="button" @click="login" class="btn btn-fill btn-info btn-round btn-wd ">Activate your account</button>
                  <br>
                </div>
              </template>
              <template v-else>
                <div class="text-center">
                  <button type="button" @click="$router.push('/dashboard')" class="btn btn-fill btn-info btn-round btn-wd ">Go to your account</button>
                  <br>
                </div>
              </template>

              <div style="font-color: red">
                {{serverResponse}}
              </div>

            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      LCheckbox,
      FadeRenderTransition,
      AuthLayout,
    },
    data () {
      return {
        model: {
          email: '',
          password: '',
          /* subscribe: true */
        },
        serverResponse: '',
      }
    },
    mounted () {
        // this.$refs.tofocus.$el.children[1].focus()
    },
    methods: {
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      },
      async login () {
        try {
          // TO CHANGE: the + thing is a hack because chrome (or Vue?) changes the + into a space when opening the link in the browser
          var response = await this.$store.dispatch('login', {email: this.$route.query.email2.split(' ').join('+'), password: this.$route.query.userActivationCode})

          if (response && response.errors) {
            this.serverResponse = response.errors.reduce((accumulator, currentValue) => accumulator + '; ' + currentValue)
          }
        }
        catch (error) {
          console.log('login(): error:', error)
        }
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
